require('angular/libs/avant/filters');
